import React, { FC } from 'react';

import { A, Article, CONTACT_URL, Document, P, Rows } from './Layout';

const Tokushoho: FC = () => (
  <Document title="特定商取引法に基づく表記" enactedOn="2026年9月11日" enactedLabel=" 現在">
    <Rows
      rows={[
        { label: '販売事業者', value: 'チェック運営' },
        { label: '運営責任者', value: '請求があった場合に遅滞なく開示します。' },
        { label: '所在地', value: '請求があった場合に遅滞なく開示します。' },
        { label: '電話番号', value: '請求があった場合に遅滞なく開示します。' },
        {
          label: 'お問い合わせ',
          value: <A href={CONTACT_URL}>お問い合わせフォーム</A>,
        },
        {
          label: '販売価格',
          value:
            'Premium 年額 4,900円／月額 490円（いずれも税込、2026年9月11日現在）。最新の価格は App Store 上の表示によります。',
        },
        {
          label: '商品代金以外の必要料金',
          value: 'アプリのダウンロードおよび利用に必要な通信料は、お客様のご負担となります。',
        },
        {
          label: '支払方法',
          value: 'App Store を通じた、Apple アカウントに登録された決済手段によるお支払い',
        },
        {
          label: '支払時期',
          value:
            '購入手続の完了時にお支払いいただきます。以後は、解約されない限り、各更新日に自動的に課金されます。',
        },
        { label: '提供時期', value: '決済の完了後、ただちにご利用いただけます。' },
        { label: '動作環境', value: 'iOS 16.4 以降を搭載した iPhone' },
        {
          label: '返品・キャンセル',
          value:
            'デジタルコンテンツの性質上、購入手続の完了後の返品・交換はお受けできません。返金の可否および手続は Apple の定めに従います。',
        },
        {
          label: '解約について',
          value:
            'iOS の「設定」内のサブスクリプションの管理画面から、更新日の24時間前までに解約してください。',
        },
      ]}
    />

    <Article title="自動更新について">
      <P>
        Premium は自動更新のサブスクリプションです。期間満了の24時間以上前に解約されない限り、同一の期間および料金で自動的に更新されます。解約は iOS の「設定」内のサブスクリプションの管理画面から行ってください。本アプリからの退会やペアの解除では課金は停止しません。
      </P>
      <P>
        ペアのいずれか一方が Premium である間は、ペアの双方について無料プランの上限が適用されません。詳しくは利用規約をご確認ください。
      </P>
    </Article>
  </Document>
);

export default Tokushoho;
